import { Component, HostListener, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IconButtonComponent } from './button.icon.component';

@Component({
    selector: 'app-checkmark-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class CheckmarkButtonComponent extends IconButtonComponent implements OnChanges, OnInit {
    @Input() selected: boolean;

    spinnerSize = 21;
    private hasHover = false;

    constructor() {
        super();
        this.icon = 'check_circle';
    }

    @HostListener('mouseenter') onMouseEnter() {
        this.hasHover = true;
        this.icon = this.selected ? 'check_circle' : 'check_circle_outline';
    }

    @HostListener('mouseleave') onMouseLeave() {
        this.hasHover = false;
        this.icon = 'check_circle';
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if ('selected' in changes) {
            this.updateSelected();
        }
    }

    ngOnInit() {
        super.ngOnInit();
        this.updateSelected();
    }

    updateSelected() {
        if (this.selected) {
            this.buttonClassSet.add('mat-button-success');
            this.icon = 'check_circle';
        } else {
            this.buttonClassSet.delete('mat-button-success');
            this.icon = this.hasHover ? 'check_circle_outline' : 'check_circle';
        }
    }
}
